"use client";

import type { ReactNode } from "react";
import type { ResponsiveValue } from "@chakra-ui/react";
import { Card } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";
import { PUBLIC_CONTENT_SPACING, PUBLIC_NAVBAR_WIDTH } from "./public-layout-constants";

interface PublicGlassPanelProps {
  children: ReactNode;
  maxW?: string;
  p?: ResponsiveValue<number | string>;
  flex?: number | string;
  minW?: number | string;
}

export function PublicGlassPanel({
  children,
  maxW = PUBLIC_NAVBAR_WIDTH,
  p = PUBLIC_CONTENT_SPACING.cardPadding,
  flex,
  minW,
}: PublicGlassPanelProps) {
  const theme = useThemeTokens();

  return (
    <Card
      p={p}
      w="100%"
      maxW={maxW}
      mx="auto"
      flex={flex}
      minW={minW}
    >
      {children}
    </Card>
  );
}
